import { useContext } from 'react'

import UltraModuleBundlingContext from '@contexts/ultraModuleBundlingContext'

const useIsInUltraModuleBundling = (): boolean =>
  !!useContext(UltraModuleBundlingContext)

export default useIsInUltraModuleBundling
